import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import withTranslation from '@helpers/i18n';
import AsyncComponent from '@components/async_components';
import { getNotifications } from './actions';
import { providerFor } from './provider_for';
import iconNotification from 'nav-icons/notification.svg';

const WidgetNotificationsList = styled.div`
  & a {
    display: inline-block;
    padding: 0 !important;
    color: var(--primary) !important;
    font-size: 16px !important;
    font-weight: bold !important;
  }
`;

const WidgetNotificationsHeader = styled.div`
  background: #eeeeee;
  padding: 10px 15px;
`;

const WidgetNotificationsFooter = styled.a`
  padding: 10px 15px !important;
  text-align: center !important;
  display: block !important;
  color: var(--primary) !important;
  text-decoration: none;

  &:hover {
    background: #f5f5f5;
  }
`;

const NotificationDropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const DropdownButton = styled.a`
  display: inline-flex;
  align-items: center;
  padding: 8px;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    opacity: 0.8;
  }
`;

const DropdownMenu = styled.ul`
  position: absolute;
  top: 100%;
  right: 0;
  width: 600px;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  list-style: none;
  margin: 0;
  padding: 0;
  z-index: 1000;
  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  visibility: ${(props) => (props.$isOpen ? 'visible' : 'hidden')};
  transform: ${(props) => (props.$isOpen ? 'translateY(0)' : 'translateY(-10px)')};
  transition: all 0.2s ease-in-out;
  pointer-events: ${(props) => (props.$isOpen ? 'auto' : 'none')};

  & > li {
    list-style: none;
    margin: 0;
    padding: 0;
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    overflow: hidden;
  }
`;

const RelativeContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const UnseenNotification = styled.span`
  display: block;
  width: 20px;
  height: 20px;
  line-height: 16px;
  text-align: center;
  color: white;
  font-size: 12px;
  background: var(--alert, #e8220d);
  border-radius: 50%;
  position: absolute;
  top: -5px;
  right: -5px;
  border: 2px solid #ffffff;
`;

const NotificationIcon = styled.img`
  width: 23px;
  height: 26px;
`;

class WidgetNotifications extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      notifications: [],
      totalUnseen: 0,
      isOpen: false,
    };

    this._renderNofitication = this._renderNofitication.bind(this);
  }

  componentDidMount() {
    this.setNotificationsStatus();
  }

  setNotificationsStatus = () => {
    getNotifications({ first: 3, only_unseen: true }).then(
      ({ notifications, notifications_summary }) => {
        this.setState({ notifications, totalUnseen: notifications_summary.total_unseen });
      },
    );
  };

  handleMouseEnter = () => {
    this.setState({ isOpen: true });
  };

  handleMouseLeave = () => {
    this.setState({ isOpen: false });
  };

  current_zone_unread_notifications_path() {
    const { zone } = this.props;
    return `/${I18n.locale}/${zone}/notifications`;
  }

  _renderNofitication(notification) {
    return (
      <AsyncComponent
        key={notification.id}
        moduleProvider={providerFor(notification.event)}
        componentProps={{ ...notification, handleClick: this.setNotificationsStatus }}
      />
    );
  }

  render() {
    const { notifications, totalUnseen, isOpen } = this.state;
    const { t } = this.props;

    return (
      <NotificationDropdownContainer
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <DropdownButton
          data-purpose="notification_dropdown_button"
          href="#"
          onClick={(e) => e.preventDefault()}
        >
          <RelativeContainer>
            <NotificationIcon src={iconNotification} alt="icon-notification" />
            {totalUnseen > 0 && (
              <UnseenNotification data-purpose="notifications_unread_count">
                {totalUnseen}
              </UnseenNotification>
            )}
          </RelativeContainer>
        </DropdownButton>

        <DropdownMenu $isOpen={isOpen}>
          <li>
            <WidgetNotificationsHeader>{t('.notifications')}</WidgetNotificationsHeader>

            <WidgetNotificationsList>
              {notifications.map((notification) => this._renderNofitication(notification))}
            </WidgetNotificationsList>

            <WidgetNotificationsFooter
              href={this.current_zone_unread_notifications_path()}
              data-purpose="go_to_notifications_link"
            >
              {t('.see_notifications')}
            </WidgetNotificationsFooter>
          </li>
        </DropdownMenu>
      </NotificationDropdownContainer>
    );
  }
}

WidgetNotifications.propTypes = {
  t: PropTypes.func.isRequired,
  zone: PropTypes.string.isRequired,
};

export default withTranslation('js.scheduling.notifications.widget')(WidgetNotifications);
